/**
 * timeoutPromise() does the same thing as setTimeout but returns a promise which resolves after the delay.
 * Useful for promise chaining or awaiting.
 *
 * @param {number} ms Amount of time to wait before resolving, in milliseconds.
 *
 * @return {Promise<any>}
 */
export const timeoutPromise = (ms) => new Promise((resolve) => { setTimeout(resolve, ms); });
